import React from 'react';
import { Icon } from './Icon.js';
export const IconBag = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 10.0047L8.62811 4.97686C8.84056 3.27625 10.2862 2 12 2C13.7138 2 15.1594 3.27625 15.3719 4.97686L16 10.0047", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M22 10V11L18 21H6L2 11V10H22Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M10 14H14", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBag.js.map